import { toastr } from 'react-redux-toastr';
import { BASE_PRINT_AGENT_URL } from '../../config/endpoints';
import { DATE_TIME_FORMAT } from '../../config/locale';
import { tzNormalizeDate } from '../date';
import { numberFormatter } from '../number';
import {
  addQrCode,
  addText,
  createPdfDocument,
  paragraphSize,
  setFont,
  y,
} from '../pdf';
import { addSaleVoucherCopies } from './TotalPosSale';

const myX = 3;
let myY = y;
const margin = 3;

const preFooter =
  'Representación Impresa del Comprobante de Venta\n' +
  'Electronica, Puede consultarlo en: www.civa.com.pe/\n' +
  'Autorizado mediante Resolución de Intendencia:\n' +
  'Número 0180050002242/SUNAT\n' +
  'Términos y Condiciones: www.civa.com.pe/\n';

const qrWidth = 35;
const qrHeight = 35;

const printLine = (doc, factor = 1) => {
  addText(
    doc,
    '----------------------------------------------------------------------------',
    40,
    (myY += margin * factor),
    80,
  );
};

const printCompanyFields = (doc) => {
  setFont(doc, 'bold');
  doc.setFontSize(12);
  addText(doc, 'TURISMO CIVA S.A.C.', 40, myY, 80);
  setFont(doc);
  addText(doc, 'Si va de viaje, ¡viaje en Civa!', 40, (myY += margin + 2), 80);
  addText(doc, 'R.U.C 20102427891', 40, (myY += margin + 2), 80);
  addText(doc, 'JR SANCHO DE RIVERA 1184', 40, (myY += margin + 2), 80);
  addText(doc, 'URB. MONSERRATE LIMA', 40, (myY += margin + 2), 80);
  addText(
    doc,
    'Central Telefónica: (511) 418-1111',
    40,
    (myY += margin + 2),
    80,
  );
  doc.setFontSize(paragraphSize);
  printLine(doc);
  doc.setFontSize(12);
};

const printExcessBaggageTicketFields = (
  doc,
  { issuingAgency, createDate, voucherType, ticketCode },
) => {
  const agencyName = doc.splitTextToSize(
    `Agencia de Emisión: ${issuingAgency}`,
    75,
  );
  addText(doc, agencyName, myX, (myY += margin + 2), 75, 'left');
  addText(
    doc,
    `Fecha/Hora Emisión: ${createDate}`,
    myX,
    (myY += margin * agencyName.length + 0.3 + 4),
    75,
    'left',
  );
  setFont(doc, 'bold');
  doc.setFontSize(14);
  myY += 2;

  const voucherText = doc.splitTextToSize(voucherType.toUpperCase(), 75);
  addText(doc, voucherText, 40, (myY += margin), 75);

  addText(doc, ticketCode, 40, (myY += 5.5 * voucherText.length + 2), 75);
  doc.setFontSize(paragraphSize);
  setFont(doc);
  printLine(doc);
  doc.setFontSize(12);
};

const printItineraryFields = (
  doc,
  { sourceLocationName, destinationLocationName },
) => {
  setFont(doc, 'bold');
  addText(doc, 'DATOS DE ITINERARIO:', myX, (myY += margin * 2), 75, 'left');
  setFont(doc);

  const sourceText = `Origen    :${sourceLocationName}`;
  const newSourceLocationName = doc.splitTextToSize(sourceText, 70);
  addText(doc, newSourceLocationName, myX, (myY += margin + 2), 72, 'left');

  if (newSourceLocationName.length <= 1) {
    myY += newSourceLocationName.length;
  } else {
    myY += newSourceLocationName.length * 2.8;
  }

  const destinationText = `Destino   :${destinationLocationName}`;
  const newDestinationLocationName = doc.splitTextToSize(destinationText, 70);
  addText(
    doc,
    newDestinationLocationName,
    myX,
    (myY += margin + 2),
    72,
    'left',
  );

  if (newDestinationLocationName.length <= 1) {
    myY += newDestinationLocationName.length;
  } else {
    myY += newDestinationLocationName.length * 2.8;
  }

  doc.setFontSize(paragraphSize);
  setFont(doc);
  printLine(doc);
  doc.setFontSize(12);
};

const printBusinessFields = (doc, { companyDocumentNumber, companyName }) => {
  setFont(doc, 'bold');
  addText(doc, 'DATOS DE LA EMPRESA:', myX, (myY += margin * 2), 75, 'left');
  setFont(doc);
  addText(
    doc,
    `RUC: ${companyDocumentNumber}`,
    myX,
    (myY += margin + 2),
    75,
    'left',
  );
  const conpanyNameText = `Razón Social: ${companyName}`;
  const newCompanyName = doc.splitTextToSize(conpanyNameText, 75);
  addText(doc, newCompanyName, myX, (myY += margin + 2), 75, 'left');

  if (newCompanyName.length > 1) {
    myY += newCompanyName.length;
  }

  doc.setFontSize(paragraphSize);
  printLine(doc, newCompanyName.length);
  doc.setFontSize(12);
};

const printPassengerFields = (
  doc,
  { fullName, identificationType, idDocumentNumber, ticketList },
) => {
  setFont(doc, 'bold');
  addText(doc, 'DATOS DEL PASAJERO:', myX, (myY += margin * 2), 75, 'left');
  setFont(doc);
  addText(doc, `Nombre:`, myX, (myY += margin + 2), 75, 'left');

  const fullNameText = doc.splitTextToSize(fullName, 75);
  addText(doc, fullNameText, myX, (myY += margin + 2), 75, 'left');

  if (fullNameText.length > 1) {
    myY += fullNameText.length * 2;
  }

  addText(
    doc,
    `Tipo Documento: ${identificationType}`,
    myX,
    (myY += margin + 2),
    75,
    'left',
  );
  addText(
    doc,
    `Numero de Documento: ${idDocumentNumber}`,
    myX,
    (myY += margin + 2),
    75,
    'left',
  );
  addText(doc, 'Boleto(s) de Viaje:', myX, (myY += margin + 2), 75, 'left');
  ticketList.forEach((ticket) => {
    addText(doc, ticket.documentCode, myX, (myY += margin + 2), 75, 'left');
  });
  setFont(doc);
  doc.setFontSize(paragraphSize);
  printLine(doc);
  doc.setFontSize(12);
};

const printExcessBaggageFields = (doc, { weight }) => {
  setFont(doc, 'bold');
  addText(doc, 'DATOS DEL EXCESO:', myX, (myY += margin * 2), 75, 'left');
  setFont(doc);
  addText(doc, 'Cantidad: 01', myX, (myY += margin + 2), 75, 'left');

  addText(
    doc,
    `PESO TOTAL EXCESO: ${weight} kg`,
    myX,
    (myY += margin + 2),
    75,
    'left',
  );
  setFont(doc);
  doc.setFontSize(paragraphSize);
  printLine(doc);
  doc.setFontSize(12);
};

const printPaymentFields = (
  doc,
  {
    ticketPrice,
    ticketPriceBeforeDiscount,
    ticketPriceString,
    paymentMethod,
    userName,
    paymentMethodSummaryList,
  },
) => {
  setFont(doc, 'bold');
  addText(doc, 'DATOS DE PAGO:', myX, (myY += margin * 2), 75, 'left');
  setFont(doc);
  // addText(doc, 'OP. GRATUITO', myX, (myY += margin + 2), 50, 'left');
  // addText(doc, `: ${numberFormatter({ value: 0 })}`, myX + 52, myY, 50, 'left');
  // addText(doc, 'OP. EXONERADO', myX, (myY += margin + 2), 50, 'left');
  // addText(doc, `: ${numberFormatter({ value: 0 })}`, myX + 52, myY, 50, 'left');
  addText(doc, 'OP. NO GRAVADA', myX, (myY += margin + 2), 50, 'left');
  addText(
    doc,
    `: ${numberFormatter({ value: ticketPriceBeforeDiscount })}`,
    myX + 52,
    myY,
    50,
    'left',
  );
  addText(doc, 'OP. GRAVADA', myX, (myY += margin + 2), 50, 'left');
  addText(doc, `: ${numberFormatter({ value: 0 })}`, myX + 52, myY, 50, 'left');
  addText(doc, 'OP. DESCUENTO', myX, (myY += margin + 2), 50, 'left');
  addText(
    doc,
    `: ${numberFormatter({
      value: +(ticketPriceBeforeDiscount - ticketPrice),
    })}`,
    myX + 52,
    myY,
    50,
    'left',
  );
  addText(doc, 'IGV', myX, (myY += margin + 2), 25, 'left');
  addText(doc, `: ${numberFormatter({ value: 0 })}`, myX + 52, myY, 50, 'left');
  setFont(doc, 'bold');
  doc.setFontSize(11);
  addText(
    doc,
    `IMPORTE TOTAL A PAGAR : ${numberFormatter({ value: ticketPrice })}`,
    myX,
    (myY += margin + 2),
    80,
    'left',
  );
  doc.setFontSize(12);
  setFont(doc);
  const ticketPriceStringText = doc.splitTextToSize(
    `Son: ${ticketPriceString}`,
    75,
  );
  addText(doc, ticketPriceStringText, myX, (myY += margin + 2), 75, 'left');

  if (ticketPriceStringText.length <= 1) {
    myY += ticketPriceStringText.length;
  } else {
    myY += ticketPriceStringText.length * 2.8;
  }

  if (paymentMethodSummaryList && paymentMethodSummaryList.length > 1) {
    addText(doc, 'Metodos de Pago:', myX, (myY += margin + 2), 50, 'left');
    paymentMethodSummaryList.forEach((paymentMethodSummary) => {
      addText(
        doc,
        `${paymentMethodSummary.paymentMethodName}:`,
        myX,
        (myY += margin + 2),
        50,
        'left',
      );
      addText(
        doc,
        `: ${numberFormatter({ value: paymentMethodSummary.amount })}`,
        myX + 52,
        myY,
        50,
        'left',
      );
    });
  } else {
    addText(doc, 'Tipo de Pago', myX, (myY += margin + 2), 25, 'left');
    addText(doc, `: ${paymentMethod}`, myX + 25, myY, 50, 'left');
  }

  addText(doc, 'Numero Tarjeta', myX, (myY += margin + 2), 50, 'left');
  addText(doc, ': -', myX + 52, myY, 50, 'left');
  addText(doc, 'Numero Voucher', myX, (myY += margin + 2), 50, 'left');
  addText(doc, ': -', myX + 52, myY, 50, 'left');
  addText(doc, 'Usuario', myX, (myY += margin + 2), 25, 'left');
  addText(doc, `: ${userName}`, myX + 25, myY, 50, 'left');
  addText(doc, preFooter, myX, (myY += margin * 3), 74, 'left');
};

const printOperationDetails = (
  doc,
  {
    createDate,
    ticketCode,
    voucherType,
    paymentMethod,
    userName,
    ticketPrice,
    paymentMethodSummaryList,
  },
) => {
  myY = 20;
  doc.addPage('p', 'mm', [80, 40]);
  doc.setFontSize(paragraphSize);
  setFont(doc);
  setFont(doc, 'bold');
  addText(doc, 'Detalle de Operación', myX, (myY += margin), 75, 'left');
  setFont(doc);
  printLine(doc);
  addText(
    doc,
    `Fecha/Hora Emisión : ${createDate}`,
    myX,
    (myY += margin),
    75,
    'left',
  );
  addText(
    doc,
    `${voucherType} : ${ticketCode}`,
    myX,
    (myY += margin),
    75,
    'left',
  );

  const isMultiPayment =
    Array.isArray(paymentMethodSummaryList) &&
    paymentMethodSummaryList.length > 1;

  if (isMultiPayment) {
    addText(doc, 'Tipo Pago :', myX, (myY += margin), 75, 'left');
    paymentMethodSummaryList.forEach((payment) => {
      const methodLines = doc.splitTextToSize(payment.paymentMethodName, 44);
      addText(doc, methodLines, myX, (myY += margin), 44, 'left');
      addText(doc, numberFormatter({ value: payment.amount }), myX + 50, myY);
      if (methodLines.length > 1) {
        myY += margin * (methodLines.length - 1);
      }
    });
  } else {
    addText(
      doc,
      `Tipo Pago : ${paymentMethod}`,
      myX,
      (myY += margin),
      75,
      'left',
    );
  }

  addText(
    doc,
    `IMPORTE TOTAL A PAGAR : ${numberFormatter({ value: ticketPrice })}`,
    myX,
    (myY += margin),
  );
  addText(doc, `Usuario : ${userName}`, myX, (myY += margin));
};

const addTicket = async (
  doc,
  {
    excessBaggageTicketFields: {
      issuingAgency,
      createDate,
      voucherType,
      ticketCode,
    },
    passengerFields: {
      fullName,
      identificationType,
      idDocumentNumber,
      ticketList,
    },
    itineraryFields: {
      routeName,
      departureTime,
      sourceLocationName,
      destinationLocationName,
    },
    excessBaggageFields: { weight },
    paymentFields: {
      ticketPrice,
      ticketPriceBeforeDiscount,
      ticketPriceString,
      paymentMethod,
      userName,
      companyDocumentNumber,
      companyName,
      paymentMethodSummaryList,
    },
  },
) => {
  await addQrCode(doc, ticketCode, 22.5, 0, qrWidth, qrHeight);
  myY += 32;
  printCompanyFields(doc);
  printExcessBaggageTicketFields(doc, {
    issuingAgency,
    createDate,
    voucherType,
    ticketCode,
  });
  printItineraryFields(doc, {
    routeName,
    departureTime,
    sourceLocationName,
    destinationLocationName,
  });
  printPassengerFields(doc, {
    fullName,
    identificationType,
    idDocumentNumber,
    ticketList,
  });
  // FACTURA
  if (companyDocumentNumber)
    printBusinessFields(doc, {
      companyDocumentNumber,
      companyName,
    });
  printExcessBaggageFields(doc, {
    weight,
  });
  printPaymentFields(doc, {
    ticketPrice,
    ticketPriceString,
    paymentMethod,
    userName,
    ticketPriceBeforeDiscount,
    paymentMethodSummaryList,
  });
  printOperationDetails(doc, {
    createDate,
    ticketCode,
    voucherType,
    paymentMethod,
    userName,
    ticketPrice,
    paymentMethodSummaryList,
  });
  myY = 5;
};

const formatTicket = (ticket) => {
  const transaction = ticket.transactions[0];
  const formatedTicket = {
    excessBaggageTicketFields: {
      issuingAgency: `${ticket.agency.name}\n${ticket.agency.address}`,
      createDate: tzNormalizeDate({
        date: ticket.documentAssignmentDate,
        format: DATE_TIME_FORMAT,
      }),
      voucherType: transaction.voucherType.name,
      ticketCode: ticket.fullDocumentCode,
    },
    passengerFields: {
      fullName: ticket.customer.fullName,
      identificationType: ticket.customer.identificationType.name,
      idDocumentNumber: ticket.customer.idDocumentNumber,
      ticketList: ticket.ticketList,
    },
    itineraryFields: {
      routeName: ticket.itinerary.routeName,
      departureTime: tzNormalizeDate({
        date: ticket.itinerary.departureTime,
        format: DATE_TIME_FORMAT,
      }),
      sourceLocationName: ticket.itinerary.sourceLocation.name,
      destinationLocationName: ticket.itinerary.destinationLocation.name,
    },
    excessBaggageFields: {
      weight: ticket.weight,
    },
    paymentFields: {
      ticketPrice: ticket.price,
      ticketPriceBeforeDiscount: ticket.priceBeforeDiscount,
      ticketPriceString: ticket.priceString,
      paymentMethod: transaction.paymentMethod.name,
      userName: ticket.user.customer.fullName,
      companyDocumentNumber: ticket.business
        ? ticket.business.businessTaxId
        : null,
      companyName: ticket.business ? ticket.business.name : null,
      paymentMethodSummaryList: ticket.paymentMethodSummaryList,
    },
  };

  return formatedTicket;
};

function arrayBufferToBase64(buffer) {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
}

const printExcessBaggage = async (ticket) => {
  const doc = createPdfDocument('p', 'mm', [80, 375]);
  const formatedTicket = formatTicket(ticket);
  await addTicket(doc, formatedTicket);
  addSaleVoucherCopies(doc, ticket.totalPosTransactions);
  doc.autoPrint();
  const arrayBuffer = doc.output('arraybuffer');

  const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
  const blobUrl = URL.createObjectURL(blob);
  const pdfBase64 = arrayBufferToBase64(arrayBuffer);

  try {
    await fetch(`${BASE_PRINT_AGENT_URL}/health`);
  } catch {
    window.open(blobUrl, '_blank');
    toastr.error(
      'Error',
      'El agente de impresión no está corriendo. Abre print-agent.exe primero.',
    );
    return;
  }

  try {
    const response = await fetch(`${BASE_PRINT_AGENT_URL}/print`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ pdfBase64, printingType: 'voucher' }),
    });

    if (!response.ok) {
      const errData = await response.json();
      throw new Error(errData.error || 'Error al imprimir');
    }
  } catch (err) {
    window.open(blobUrl, '_blank');
    toastr.error('Error', err.message);
  }
};

// eslint-disable-next-line import/prefer-default-export
export { printExcessBaggage };
